import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"
import _ from "lodash"
export default {
  get: function ($, companyId = null, projectId = null, departmentId = null) {
    return new Promise((resolve, reject) => {
      let path = projectId ? `/projects/${projectId}` : `projects/company/${companyId}/list`
      if (departmentId) {
        path += `?department=${departmentId}`
      }
      HTTP.get(path)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  create: function ($, project) {
    if (_.isObject(project.company)) project.company = project.company.pk
    let companyId = project.company
    return new Promise((resolve, reject) => {
      HTTP.post(`projects/company/${companyId}/list`, project)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  duplicate: function ($, projectId, form) {
    return new Promise((resolve, reject) => {
      HTTP.post(`projects/${projectId}/duplicate`, form)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  update: function ($, projectId, project) {
    if (_.isObject(project.company)) project.company = project.company.pk
    return new Promise((resolve, reject) => {
      HTTP.patch(`/projects/${projectId}`, project)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  async remove($, projectId) {
    const path = `/projects/${projectId}`
    return HTTP.delete(path).then(response => response.data)
  },
  get_dashboard: function ($, projectId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/${projectId}/dashboard`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  get_gantt_data: function ($, projectId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/${projectId}/gantt`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  getFeed: function ($, projectId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/${projectId}/feed`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  getHome: function () {
    return new Promise((resolve, reject) => {
      HTTP.get(`/projects/home`)
        .then(response => resolve(response.data))
        .catch(error => reject(error))
    })
  },
  areas: {
    get: function ($, projectId) {
      return new Promise((resolve, reject) => {
        HTTP.get(`/projects/${projectId}/areas`)
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    },
    delete: function ($, projectId, params) {
      return new Promise((resolve, reject) => {
        HTTP.delete(`/projects/${projectId}/areas`, { params: params })
          .then(response => resolve(response.data))
          .catch(error => reject(error))
      })
    }
  }
}
